// ThemeToggle.jsx - Replace your existing file with this
import { useTheme } from "../contexts/ThemeContext";

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  const handleClick = () => {
    console.log("ThemeToggle clicked! Current theme:", theme); // Debug log
    toggleTheme();
  };

  return (
    <span
      onClick={handleClick}
      className="cursor-pointer select-none text-xl p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-md transition-colors"
      aria-label={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
      role="button"
      tabIndex="0"
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      }}
    >
      {theme === "light" ? "🌙" : "☀️"}
    </span>
  );
}